export const colors = {
  primary: '#0062fc',
  secondary: '#04953b',
  white: '#fff',
  black: '#000',
  transparent: '#0000',
};